import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../Authentication/AuthProvider';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import useCurrentUser from '../Authentication/useCurrentUser';
import { FiBell, FiMenu, FiUser, FiSettings, FiLogOut, FiChevronDown } from 'react-icons/fi';

const AppHeader = ({ toggleSidebar }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const userData = useCurrentUser() || {};

  const initials = `${userData.firstName?.[0] || ''}${userData.lastName?.[0] || ''}`.toUpperCase() || 'U';
  const fullName = [userData.firstName, userData.lastName].filter(Boolean).join(' ') || 'User';
  const role = userData.role || '';

  useEffect(() => {
    if (userData.profileImage) {
      axiosInstance.get(`/api/user/profile-image/${userData.profileImage}`, { responseType: 'blob' })
        .then(r => setProfileImage(URL.createObjectURL(r.data)))
        .catch(() => { });
    }
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="sidebar-toggle-btn" onClick={toggleSidebar} aria-label="Toggle sidebar">
          <FiMenu size={18} />
        </button>
        <span className="header-breadcrumb d-none d-md-block">
          Swahili For Foreigners
        </span>
      </div>

      <div className="header-right">
        <button className="header-icon-btn" aria-label="Notifications">
          <FiBell size={17} />
          <span className="header-badge" />
        </button>

        <div className="header-divider" />

        <div className="header-dropdown" ref={dropdownRef}>
          <button
            className="header-user"
            onClick={() => setDropdownOpen(o => !o)}
            aria-expanded={dropdownOpen}
          >
            <div className="header-avatar">
              {profileImage ? <img src={profileImage} alt="avatar" /> : initials}
            </div>
            <div className="header-user-info">
              <div className="header-user-name">{fullName}</div>
              <div className="header-user-role">{role}</div>
            </div>
            <FiChevronDown size={13} style={{ color: '#94a3b8', marginLeft: 2 }} />
          </button>

          <div className={`header-dropdown-menu${dropdownOpen ? ' show' : ''}`}>
            <div style={{ padding: '0.75rem 0.875rem 0.5rem', borderBottom: '1px solid #f1f5f9', marginBottom: '0.375rem' }}>
              <div style={{ fontWeight: 600, fontSize: '0.8125rem', color: '#0f172a' }}>{fullName}</div>
              <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{userData.email || role}</div>
            </div>
            <button className="header-dropdown-item" onClick={() => { navigate('/user-profile'); setDropdownOpen(false); }}>
              <FiUser size={14} /> My Profile
            </button>
            <button className="header-dropdown-item" onClick={() => setDropdownOpen(false)}>
              <FiSettings size={14} /> Settings
            </button>
            <div className="header-dropdown-divider" />
            <button className="header-dropdown-item danger" onClick={handleLogout}>
              <FiLogOut size={14} /> Sign Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
